import Button from 'components/Form/Button';
import BasicTable from 'components/Form/Table';
import UploadFile from 'components/Form/UploadFile';
import ModalAcoesDocumento from 'components/Modal/Formalizarproposal';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { Read, Update } from 'services/financing-proposals';
import {
  Load,
  StatusContent,
  TableInfo,
  TableInfoPend,
  Title,
  Touch,
} from 'ui/styled';
import {
  capitalize,
  exposeStrapiError,
  marcadorDiferente,
  parseStrapiImage,
  selectColors,
} from 'utils';
import { formatElapsedTime, parseCurrency } from 'utils/parsers';
// importação correta do modal
import { formatadores, normalizeName } from 'utils/validators';

export default function FinancingDeskFormalizar() {
  const history = useHistory();
  const navigate = useCallback((to) => history.push(`/${to}`), [history]);
  const { user, filterExpression, setModal } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  const [registers, setRegisters] = useState([]);
  const [tick, setTick] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => setTick((prev) => prev + 1), 60000);
    return () => clearInterval(interval);
  }, []);

  const handleOpenModal = (proposal) => {
    setSelectedProposal(proposal.original);
    setIsClosing(false);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsModalOpen(false);
      setSelectedProposal(null);
    }, 400);
  };
  const columns = useMemo(() => {
    const baseColumns = [
      {
        title: 'Id',
        sortable: true,
        ref: 'id',
        renderCell: ({ row }) => {
          // Verifica se foi analisado pela curadoria humana ou pelo bot
          const isAnalisadoCuradoria = row?.curadoria_analise === 'Analisado';
          const isAnalisadoBot = row?.curadoria_analise_bot === 'Analisado';
          const id = row?.id;
          if (isAnalisadoCuradoria || isAnalisadoBot) {
            return marcadorDiferente(id, '!');
          }
          return id;
        },
      },
      {
        title: 'Data',
        sortable: true,
        ref: 'date',
        renderCell: ({ row }) => formatadores.TIMESTAMP_TO_BR(row?.date),
      },
      {
        title: 'Tempo',
        renderCell: ({ row }) => {
          const diffDays = formatadores.DIFF_DAYS_NOW(row?.date);
          return (
            <span style={{ color: diffDays >= 2 ? 'red' : 'inherit' }}>
              {formatElapsedTime(row?.date)}
            </span>
          );
        },
      },
      { title: 'Proposta', ref: 'cod_proposta_externa' },
      ...(user?.administrador ||
      (user?.distribuidor && user?.distribuidores?.length > 0)
        ? [
            {
              title: 'Distribuidora',
              sortable: true,
              ref: 'distributor',
            },
          ]
        : []),
      { title: 'Integrador', sortable: true, ref: 'integrator' },
      { title: 'Cliente', sortable: true, ref: 'customer' },
      { title: 'Valor', ref: 'value' },
      { title: 'Banco', sortable: true, ref: 'bank' },
      {
        title: 'nf de produto',
        ref: 'sales_invoice',
        renderCell: ({ row }) =>
          loading === `${row?.id}-nf_venda` ? (
            <Load />
          ) : row?.original?.nf_venda?.url ? (
            <Touch
              onClick={() =>
                window.open(
                  parseStrapiImage(row?.original?.nf_venda?.url),
                  'new'
                )
              }
            >
              <TableInfo>{row?.sales_invoice}</TableInfo>
            </Touch>
          ) : (
            <UploadFile
              key={`nfv-${row.id}`}
              onChange={(file) =>
                save({ ...row?.original, nf_venda: file?.id }, row, 'nf_venda')
              }
              proposalType="A_Formalizar"
            >
              <TableInfoPend>{row?.sales_invoice}</TableInfoPend>
            </UploadFile>
          ),
      },
      {
        title: 'nf de serviço',
        ref: 'service_nf',
        renderCell: ({ row }) =>
          loading === `${row?.id}-nf_compra` ? (
            <Load />
          ) : row?.original?.nf_compra?.url ? (
            <Touch
              onClick={() =>
                window.open(
                  parseStrapiImage(row?.original?.nf_compra?.url),
                  'new'
                )
              }
            >
              <TableInfo>{row?.service_nf}</TableInfo>
            </Touch>
          ) : (
            <UploadFile
              key={`nfc-${row.id}`}
              onChange={(file) =>
                save(
                  { ...row?.original, nf_compra: file?.id },
                  row,
                  'nf_compra'
                )
              }
              proposalType="A_Formalizar"
            >
              <TableInfoPend>{row?.service_nf}</TableInfoPend>
            </UploadFile>
          ),
      },
      ...(user?.administrador || user?.perm_anexa_ccb
        ? [
            {
              title: 'CCB',
              ref: 'financing_contract',
              renderCell: ({ row }) =>
                loading === `${row?.id}-contrato_financiamento` ? (
                  <Load />
                ) : row?.original?.contrato_financiamento?.url ? (
                  <Touch
                    onClick={() =>
                      window.open(
                        parseStrapiImage(
                          row?.original?.contrato_financiamento?.url
                        ),
                        'new'
                      )
                    }
                  >
                    <TableInfo>{row?.financing_contract}</TableInfo>
                  </Touch>
                ) : (
                  <UploadFile
                    key={`ccb-${row.id}`}
                    onChange={(file) =>
                      save(
                        { ...row?.original, contrato_financiamento: file?.id },
                        row,
                        'contrato_financiamento'
                      )
                    }
                    proposalType="A_Formalizar"
                  >
                    <TableInfoPend>{row?.financing_contract}</TableInfoPend>
                  </UploadFile>
                ),
            },
          ]
        : [
            {
              title: 'CCB',
              ref: 'financing_contract',
              renderCell: ({ row }) => {
                if (row?.original?.contrato_financiamento?.url) {
                  return (
                    <Touch
                      onClick={() =>
                        window.open(
                          parseStrapiImage(
                            row?.original?.contrato_financiamento?.url
                          ),
                          'new'
                        )
                      }
                    >
                      <TableInfo>{row?.financing_contract}</TableInfo>
                    </Touch>
                  );
                }
                // Ação que será executada ao clicar
                const handleNoPermissionClick = (event) => {
                  event.preventDefault(); // Evita a ação padrão do componente
                  toast.error('Você não possui permissão para anexar.');
                };
                // Renderiza um componente clicável que dispara a mensagem de erro
                return (
                  <div
                    onClick={handleNoPermissionClick}
                    style={{ cursor: 'pointer' }}
                  >
                    <TableInfoPend>{row?.financing_contract}</TableInfoPend>
                  </div>
                );
              },
            },
          ]),
      {
        title: 'Ciência Compra',
        ref: 'ciencia',
        renderCell: ({ row }) =>
          loading === `${row?.id}-pdf_ciencia_compra` ? (
            <Load />
          ) : row?.original?.pdf_ciencia_compra?.url ? (
            <Touch
              onClick={() =>
                window.open(
                  parseStrapiImage(row?.original?.pdf_ciencia_compra?.url),
                  'new'
                )
              }
            >
              <TableInfo>{row?.ciencia}</TableInfo>
            </Touch>
          ) : null,
      },
      {
        title: 'TAG',
        ref: 'tag',
        renderCell: ({ row }) => {
          const tagText = row?.tag;
          let tagColor;
          if (tagText === 'Aguardando anexar docs') {
            tagColor = 'orange';
          } else {
            tagColor = selectColors(tagText);
          }
          return <StatusContent color={tagColor}>{tagText}</StatusContent>;
        },
      },
      ...(user?.administrador
        ? [
            {
              title: 'Espelho da Proposta',
              ref: 'espelho',
              renderCell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    onClick={() => navigate(`proposals/financing/${row?.id}`)}
                    color="blue"
                    nospace
                    mbutton
                    small
                  >
                    Visualizar
                  </Button>
                </div>
              ),
            },
            {
              title: 'Ações',
              renderCell: ({ row }) => (
                <Button
                  onClick={() => {
                    if (row.omniId) {
                      if (row?.status_contrato === 'FINALIZADO') {
                        toast.info(
                          `Contrato com status ${row?.status_contrato}`
                        );
                        handleOpenModal(row);
                      } else {
                        setModal({
                          type: 'formalizabanco',
                          dados: row,
                          reload: () => init(),
                        });
                      }
                    } else {
                      handleOpenModal(row);
                    }
                  }}
                  color="blue"
                  nospace
                  mbutton
                  small
                >
                  {row.omniId && !(row?.status_contrato === 'FINALIZADO')
                    ? 'Formalizar'
                    : 'Aprovar'}
                </Button>
              ),
            },
            {
              title: 'Observações',
              renderCell: ({ row }) => (
                <Button
                  onClick={() => {
                    setModal({
                      type: 'observacao',
                      dados: row,
                      origem: 'A Formalizar',
                      reload: () => init(),
                    });
                  }}
                  color="botao"
                  nospace
                  mbutton
                  small
                >
                  Adicionar
                </Button>
              ),
            },
          ]
        : []),
    ];
    return baseColumns.filter((f) => f);
  }, [loading, user, handleOpenModal, navigate]);
  const rows = useMemo(() => {
    return registers?.map((item) => {
      const propostaAprovada = item?.propostas_banco?.find(
        (p) => p.status === 'aprovado'
      );
      let textoTag = 'Aguardando anexar docs';
      if (
        item?.nf_venda?.url &&
        item?.nf_compra?.url &&
        item?.contrato_financiamento?.url
      ) {
        textoTag = 'Docs. em análise';
      }
      return {
        original: item,
        id: item?.id,
        date: item?.data_formalizar,
        formatedDate: formatadores.TIMESTAMP_TO_BR(item?.data_formalizar),
        cod_proposta_externa: normalizeName(item?.cod_proposta_externa),
        distributor: normalizeName(item?.distribuidor?.trade_name),
        distributorId: item?.distribuidor?.id,
        integrator: normalizeName(item?.integrador?.nome_fantasia),
        seller: normalizeName(item?.informacoes_projeto?.nome_vendedor),
        telephone: item?.informacoes_cliente?.telefone_celular,
        customer: normalizeName(item?.informacoes_cliente?.nome_completo),
        customerId: item?.cliente?.id,
        value: parseCurrency(item?.informacoes_projeto?.custo_total_projeto),
        status: capitalize(item?.status),
        bank: normalizeName(propostaAprovada?.banco?.nome_fantasia),
        omniId: propostaAprovada?.id_proposta_api,
        sales_invoice: item?.nf_venda?.url ? 'Anexado' : 'Anexar',
        service_nf: item?.nf_compra?.url ? 'Anexado' : 'Anexar',
        financing_contract: item?.contrato_financiamento?.url
          ? 'Anexado'
          : 'Anexar',
        ciencia: item?.pdf_ciencia_compra?.url ? 'Gerado' : 'Não gerado',
        tag: textoTag,
        curadoria_analise: item?.curadoria_analise,
        curadoria_analise_bot: item?.curadoria_analise_bot,
        cnpj_integrador: item?.integrador?.cnpj,
        cnpj_integrador_clean: item?.integrador?.cnpj.replace(/\D/g, ''),
        cpf_cnpj: item?.cliente?.cpf || item?.cliente?.cnpj,
        cpf_cnpj_clean: item?.cliente?.cpf
          ? item?.cliente?.cpf.replace(/\D/g, '')
          : item?.cliente?.cnpj.replace(/\D/g, ''),
        id_contrato_omni: item?.id_contrato_omni,
        status_contrato: item?.status_contrato,
      };
    });
  }, [registers]);
  const init = useCallback(async () => {
    setLoading(true);
    const result = await Read('?filters[status]=a_formalizar');
    setLoading(false);
    if (result && !exposeStrapiError(result)) {
      const nresult = result?.results?.sort((a, b) => b.id - a.id);
      const nextResult = nresult?.map((m) => ({
        ...m,
        bank: m?.propostas_banco?.find((f) => f.aceito),
      }));
      setRegisters(nextResult);
    }
  }, []);

  useEffect(() => {
    init();
  }, [tick, init]);

  const save = async (payload, item, mode) => {
    if (loading) return;
    setLoading(`${item?.id}-${mode}`);
    const result = await Update({ data: payload }, item?.id);
    if (result && !exposeStrapiError(result)) {
      toast.success('Anexado com sucesso');
      init();
    }
    setLoading(false);
  };

  return (
    <>
      <ContainerAuthenticated>
        <Title>Mesa de Financiamentos</Title>
        <TableWrapper title={'a Formalizar'} search>
          <BasicTable
            loading={loading}
            columns={columns}
            rows={rows?.filter(filterExpression)}
            pagination
          />
        </TableWrapper>
      </ContainerAuthenticated>
      {isModalOpen && selectedProposal && (
        <ModalAcoesDocumento
          proposal={selectedProposal}
          onClose={handleCloseModal}
          reloadContent={init}
          isClosing={isClosing}
        />
      )}
    </>
  );
}
